module.exports = __webpack_public_path__ + "static/media/notebook-03.72e538cb.png";